module.exports = __webpack_public_path__ + "five-contributors-hero-63459af3b7a629e2cd28dbec6ff8c301.png";